import { assert, hasKeysOfUnknown, isObject } from '../guards'
import type { Nullable } from '../types'

const KEY = '__gmAccessKey__'

declare global {
  interface Window {
    [KEY]: Nullable<string>
  }
}

const proto: unknown = Object.getPrototypeOf(window)

assert(isObject(proto), 'Prototype of window is not an object')

if (!(KEY in proto) || proto[KEY] === undefined) {
  Object.defineProperty(proto, KEY, { value: null, writable: true })
}

assert(hasKeysOfUnknown(proto, KEY), 'Token is not defined')

export const setToken = (token: Nullable<string>) => (proto[KEY] = token)

export const removeToken = () => (proto[KEY] = null)

export const getToken = (): Nullable<string> => {
  assert(
    typeof proto[KEY] === 'string' || proto[KEY] === null,
    `Unexpected token type: ${typeof proto[KEY]}`,
  )

  return proto[KEY]
}
